// Görünür yıllar için hücre not özeti (rozet + okunmamış nokta; Özet "Yanıt bekleyen notlar").
// Resolved isteğine PARALEL gider (grid'i beklemez, grid yanıtı geciktirmez); hata sessizdir — rozet
// yoksa tablo yine çalışır (notlar bir yardımcı yüzeydir, tabloyu kırmaz). `refreshKey` değişince
// (değer kaydı → K10 alanı iş parçacığına not yazar) yeniden çekilir; `reload` thread açıldı/yazıldı
// sonrası çağrılır. Bayat yanıt (set/yıl bu arada değişti) atılır.

import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import type { KpiNoteSummaryCell } from "@mahir/shared";
import { fetchNoteSummary, type NotesAudience } from "../api/kpi-notes";
import { noteSummaryMap } from "../lib/kpi-notes-ui";

export function useKpiNoteSummary(
  audience: NotesAudience,
  setId: string | null,
  years: number[],
  refreshKey: unknown = null,
): { cells: KpiNoteSummaryCell[]; summary: Map<string, KpiNoteSummaryCell>; reload: () => void } {
  const [cells, setCells] = useState<KpiNoteSummaryCell[]>([]);
  const [tick, setTick] = useState(0);
  const seq = useRef(0);
  const yearsKey = years.join(",");

  useEffect(() => {
    if (!setId || years.length === 0) {
      setCells([]);
      return;
    }
    const mine = ++seq.current;
    fetchNoteSummary(audience, setId, years)
      .then((list) => {
        if (seq.current === mine) setCells(list);
      })
      .catch(() => {
        if (seq.current === mine) setCells([]);
      });
  }, [audience, setId, yearsKey, refreshKey, tick]);

  const summary = useMemo(() => noteSummaryMap(cells), [cells]);
  const reload = useCallback(() => setTick((t) => t + 1), []);
  return { cells, summary, reload };
}
